<ngx-channel [view]="view" (linkClicked)="handleLinkClick($event)" (orderIdEvent)="emitOrderIdEvent($event)"></ngx-channel>
